import { debug } from './utils';
import * as CryptoJS from 'crypto-js';
const secretKey = '3fce7552-e590-4e5c-95bf-f93ca29f9416';

export function getDateSeed(date: Date, difficulty: number): number {
    // Calculate days since 1970-01-01
    const timestamp = date.getTime(); // milliseconds since epoch
    const daysSinceEpoch = Math.floor(timestamp / (1000 * 60 * 60 * 24)) * 10 + difficulty;

    // Convert days to a 4-byte array (32-bit integer)
    const buffer = new ArrayBuffer(4);
    const view = new DataView(buffer);
    view.setUint32(0, daysSinceEpoch, false); // big-endian
    const bytes = new Uint8Array(buffer);

    // Compute HMAC-SHA256 of the bytes with the secret key
    const wordArray = CryptoJS.lib.WordArray.create(bytes);
    const hmac = CryptoJS.HmacSHA256(wordArray, secretKey);
    const signature = hmac.words[0] >>> 0; // first 32 bits, unsigned (>>> ensures unsigned shift)

    // Combine days and signature into a 64-bit integer
    const param = (BigInt(daysSinceEpoch) << 32n) | BigInt(signature);
    return Number(param);  //.toString(); // return as string for URL use
}

export function verifyDateParam(paramStr: string): [Date | null, number | null] {
    try {
        const param = BigInt(paramStr);
        // Extract days (upper 32 bits) and signature (lower 32 bits)
        const daysSinceEpoch = Number(param >> 32n);
        const receivedSignature = Number(param & 0xFFFFFFFFn); // mask to get lower 32 bits

        // Recompute HMAC-SHA256 for verification
        const buffer = new ArrayBuffer(4);
        const view = new DataView(buffer);
        view.setUint32(0, daysSinceEpoch, false);
        const bytes = new Uint8Array(buffer);
        const wordArray = CryptoJS.lib.WordArray.create(bytes);
        const hmac = CryptoJS.HmacSHA256(wordArray, secretKey);
        const expectedSignature = hmac.words[0] >>> 0;

        // Check if the signature matches
        if (receivedSignature === expectedSignature) {
            // Convert days back to Date
            const date = new Date(1970, 0, 1); // January 1, 1970
            date.setDate(date.getDate() + Math.floor(daysSinceEpoch / 10));
            const difficulty = daysSinceEpoch % 10;
            debug('Verified date:', date, 'difficulty:', difficulty);
            return [date, difficulty];
        } else {
            return [null, null]; // Invalid parameter
        }
    } catch (error) {
        console.error('Error verifying date param:', error);
        return [null, null]; // Error parsing parameter
    }
}
